/* tslint:disable */
/* eslint-disable */
/* @relayHash 374e79ec67c5ccb84d043059f95549f2 */

import { ConcreteRequest } from "relay-runtime";
export type DelegateProfilePage_RequestBackgroundCheckMutationVariables = {
    delegateUUID: string;
    email?: string | null;
    requestDBS: boolean;
    isRenewal?: boolean | null;
    onlyDBS?: boolean | null;
    idExpiry?: string | null;
    isCAA?: boolean | null;
};
export type DelegateProfilePage_RequestBackgroundCheckMutationResponse = {
    readonly requestBackgroundCheck: boolean;
};
export type DelegateProfilePage_RequestBackgroundCheckMutation = {
    readonly response: DelegateProfilePage_RequestBackgroundCheckMutationResponse;
    readonly variables: DelegateProfilePage_RequestBackgroundCheckMutationVariables;
};



/*
mutation DelegateProfilePage_RequestBackgroundCheckMutation(
  $delegateUUID: UUID!
  $email: String
  $requestDBS: Boolean!
  $isRenewal: Boolean
  $onlyDBS: Boolean
  $idExpiry: Time
  $isCAA: Boolean
) {
  requestBackgroundCheck(delegateUUID: $delegateUUID, requestDBS: $requestDBS, email: $email, isRenewal: $isRenewal, onlyDBS: $onlyDBS, idExpiryDate: $idExpiry, isCAA: $isCAA)
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "delegateUUID",
            "type": "UUID!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "email",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "requestDBS",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isRenewal",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "onlyDBS",
            "type": "Boolean",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "idExpiry",
            "type": "Time",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isCAA",
            "type": "Boolean",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "requestBackgroundCheck",
            "args": [
                {
                    "kind": "Variable",
                    "name": "delegateUUID",
                    "variableName": "delegateUUID"
                },
                {
                    "kind": "Variable",
                    "name": "email",
                    "variableName": "email"
                },
                {
                    "kind": "Variable",
                    "name": "idExpiryDate",
                    "variableName": "idExpiry"
                },
                {
                    "kind": "Variable",
                    "name": "isCAA",
                    "variableName": "isCAA"
                },
                {
                    "kind": "Variable",
                    "name": "isRenewal",
                    "variableName": "isRenewal"
                },
                {
                    "kind": "Variable",
                    "name": "onlyDBS",
                    "variableName": "onlyDBS"
                },
                {
                    "kind": "Variable",
                    "name": "requestDBS",
                    "variableName": "requestDBS"
                }
            ],
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "DelegateProfilePage_RequestBackgroundCheckMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "DelegateProfilePage_RequestBackgroundCheckMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "DelegateProfilePage_RequestBackgroundCheckMutation",
            "id": null,
            "text": "mutation DelegateProfilePage_RequestBackgroundCheckMutation(\n  $delegateUUID: UUID!\n  $email: String\n  $requestDBS: Boolean!\n  $isRenewal: Boolean\n  $onlyDBS: Boolean\n  $idExpiry: Time\n  $isCAA: Boolean\n) {\n  requestBackgroundCheck(delegateUUID: $delegateUUID, requestDBS: $requestDBS, email: $email, isRenewal: $isRenewal, onlyDBS: $onlyDBS, idExpiryDate: $idExpiry, isCAA: $isCAA)\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '08878fa31b61ae48dde035d32b7a7a0f';
export default node;
